var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import AonPannel from "../../components/core/AonPannel";
import "./MarketDetails.scss";
import { postAMBestFinsData } from "../../api/marketData/amBestFinData";
import { AonCheckbox } from "../../components/core/AonCheckbox";
import { getApplicationConfig, getDDMMYYYY } from "../../constants/utilities";
import { getSubscribeEntities, enableMarketFavorite, checkmarketSubscription, enableMarketNews } from "../../api/marketData/apiSubscribedEntities";
import { useAppInfoStore } from "../../store";
import { submitNotificationAlert } from "../../api/researchAndNotification";
import { useSearchParams } from "react-router-dom";
import { UuiFlexlayout, UuiOverlayLoader, UuiSpinner } from "@aonunited/react";
import { AonButton } from "../../components/core/AonButton";
import { BUTTON_VARIANT } from "../../components/core/AonButton/consts";
import { getAMBestDetailsData } from "../../api/marketData/amBestDetailsData";
import { getSandPDetailsData } from "../../api/marketData/s&pDetailsData";
import { MarketDetailsPan } from "./MarketDetailsPanel";
import { MarketTypeSpecificPan } from "./MarketTypeSpecificPan";
import { MarketNewsAndResearchpan } from "./MarketNewsAndResearch";
import { MarketGuideStatusPan } from "./MarketGuideStatuspan";
import { getMarketInfoPublic } from "../../api/marketData/getMarketInfo";
import { MarketAddtionalInfo } from "./MarketAdditionalPublicInfo";
import { MarketIntermediaries } from "./MarketIntermediariesPan";
import { getOktaUserEmail, isInternaluser } from "../../api/auth/okta";
import { allFinancialKeysInOrder } from "../../constants/Constants";
var MarketDetails = observer(function () {
    var _a = useState(""), marketName = _a[0], setMarketName = _a[1];
    var _b = useState(""), marketType = _b[0], setMarketType = _b[1];
    var appConfig = getApplicationConfig();
    var appinfo = useAppInfoStore();
    var searchParams = useSearchParams()[0];
    var id = searchParams.get("MarketId");
    var _c = useState(false), financialLoader = _c[0], setFinancialLoader = _c[1];
    var _d = useState(false), aMBestLoader = _d[0], setAMBestLoader = _d[1];
    var _e = useState(false), sANDPLoader = _e[0], setSANDPLoader = _e[1];
    var _f = useState(), pageCheckBoxValues = _f[0], setPageCheckBoxValues = _f[1];
    var _g = useState([]), financialData = _g[0], setFinancialData = _g[1];
    var _h = useState([]), amBestData = _h[0], setAmBestData = _h[1];
    var _j = useState([]), sANDPData = _j[0], setSANDPData = _j[1];
    var _k = useState(false), finError = _k[0], setFinError = _k[1];
    var _l = useState(false), aMBesterror = _l[0], setAMBesterror = _l[1];
    var _m = useState(false), sandPError = _m[0], setSandPError = _m[1];
    var _o = useState(false), initialApiLoading = _o[0], setInitialAPiLoading = _o[1];
    var _p = useState(false), showData = _p[0], setShowData = _p[1];
    useEffect(function () {
        fetchConfig();
    }, [appinfo.IEContactID]);
    var fetchConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
        var getAppCOnfig, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!(appinfo.IEContactID && id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getSubscribeEntities(appinfo.IEContactID, id)];
                case 1:
                    getAppCOnfig = _a.sent();
                    setPageCheckBoxValues(getAppCOnfig.data[0]);
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var body = document.body;
        body.setAttribute("style", "");
        FetchMarketData();
        return function () {
            document.title = "".concat(appConfig.applicationName);
        };
    }, []);
    var FetchMarketData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _showData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchMarketInfo()];
                case 1:
                    _showData = _a.sent();
                    if (_showData) {
                        fetchFinacialData();
                        fetchAMBestDetails();
                        fetchSANDPDetails();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchMarketInfo = function () { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (res, rej) { return __awaiter(void 0, void 0, void 0, function () {
                    var showData_1, applicationId, payload, userEmail, marketRespone, error_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 3, , 4]);
                                setInitialAPiLoading(true);
                                showData_1 = false;
                                if (!(id && appConfig.applicationId)) return [3 /*break*/, 2];
                                applicationId = appConfig.applicationId;
                                payload = {
                                    MarketIds: Number(id).toString(),
                                    PreViewReViewGuideMode: applicationId,
                                    IsColleagueFlag: isInternaluser() //True for internal user else false
                                };
                                if (applicationId === 1 && !isInternaluser()) {
                                    userEmail = getOktaUserEmail();
                                    payload["AccountEmail"] = userEmail;
                                }
                                return [4 /*yield*/, getMarketInfoPublic(payload)];
                            case 1:
                                marketRespone = _a.sent();
                                showData_1 = !!marketRespone.data.value.length;
                                if (showData_1) {
                                    handleCurrentMarket(marketRespone.data.value[0]);
                                }
                                _a.label = 2;
                            case 2:
                                res(showData_1);
                                setShowData(showData_1);
                                setInitialAPiLoading(false);
                                return [3 /*break*/, 4];
                            case 3:
                                error_2 = _a.sent();
                                rej("Failed due to ".concat(error_2));
                                setInitialAPiLoading(false);
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); })];
        });
    }); };
    var fetchFinacialData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var financialDataRes, _financialData_1, item, allKeys, AddLocalSeparator, _i, allKeys_1, keys, itemValue, tempFinanacialData_1, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setFinancialLoader(true);
                    return [4 /*yield*/, postAMBestFinsData({ MarketIds: id })];
                case 2:
                    financialDataRes = _a.sent();
                    _financialData_1 = [];
                    item = financialDataRes.data.value[0];
                    if (!item.applicableToMarketFlag) {
                        setFinancialLoader(false);
                        return [2 /*return*/];
                    }
                    allKeys = Object.keys(item);
                    _financialData_1.push({
                        key: "Key Financial As of Date (".concat(item.lastRptCurrency, " ? ").concat(item.lastRptCurrency, ":\"\"}mn)"),
                        value: (item === null || item === void 0 ? void 0 : item.keyFinancialAsOfDate) ? getDDMMYYYY(item.keyFinancialAsOfDate) : null
                    });
                    AddLocalSeparator = function (no) {
                        return no.toLocaleString(undefined, {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1
                        });
                    };
                    for (_i = 0, allKeys_1 = allKeys; _i < allKeys_1.length; _i++) {
                        keys = allKeys_1[_i];
                        itemValue = item[keys];
                        if ((itemValue && typeof itemValue === 'object' && itemValue.displayName && (itemValue).applicableToMarketFlag)) {
                            if (itemValue.displayName.includes("%")) {
                                _financialData_1.push({
                                    key: itemValue === null || itemValue === void 0 ? void 0 : itemValue.displayName,
                                    value: (itemValue === null || itemValue === void 0 ? void 0 : itemValue.value) ? AddLocalSeparator(itemValue === null || itemValue === void 0 ? void 0 : itemValue.value) : ""
                                });
                            }
                            else {
                                _financialData_1.push({
                                    key: itemValue === null || itemValue === void 0 ? void 0 : itemValue.displayName,
                                    value: (itemValue === null || itemValue === void 0 ? void 0 : itemValue.value) ? AddLocalSeparator((itemValue === null || itemValue === void 0 ? void 0 : itemValue.value) / 1000) : null,
                                });
                            }
                        }
                    }
                    tempFinanacialData_1 = [];
                    //For the first Field 
                    tempFinanacialData_1.push({
                        key: item.lastRptCurrency ? "Key Financial As of Date (".concat(item.lastRptCurrency, "mn)") : "Key Financial As of Date",
                        value: (item === null || item === void 0 ? void 0 : item.keyFinancialAsOfDate) ? getDDMMYYYY(item.keyFinancialAsOfDate) : null
                    });
                    allFinancialKeysInOrder.forEach(function (key) {
                        var findKeyData = _financialData_1.find(function (item) { return item.key === key; });
                        if (findKeyData) {
                            tempFinanacialData_1.push(findKeyData);
                        }
                    });
                    setFinancialData(tempFinanacialData_1);
                    setFinancialLoader(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    setFinancialLoader(false);
                    setFinError(true);
                    console.log("error", error_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var fetchAMBestDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var amBestData_1, _amBestData, item, allKeys, _i, allKeys_2, keys, itemValue, error_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!id) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    setAMBestLoader(true);
                    return [4 /*yield*/, getAMBestDetailsData({ MarketId: Number(id) })];
                case 2:
                    amBestData_1 = _b.sent();
                    if ((_a = amBestData_1 === null || amBestData_1 === void 0 ? void 0 : amBestData_1.data) === null || _a === void 0 ? void 0 : _a.applicableToMarketFlag) {
                        _amBestData = [];
                        item = amBestData_1.data.fields;
                        allKeys = Object.keys(item);
                        for (_i = 0, allKeys_2 = allKeys; _i < allKeys_2.length; _i++) {
                            keys = allKeys_2[_i];
                            itemValue = item[keys];
                            if ((itemValue && typeof itemValue === 'object' && itemValue.applicableToMarketFlag && (itemValue).showLabel)) {
                                if (keys === "BestRating") {
                                    _amBestData.push({
                                        key: "AM Best Rating",
                                        value: itemValue.value,
                                    });
                                }
                                else if (keys === "RatingOutlook") {
                                    _amBestData.push({
                                        key: "AM Best Outlook/Implication",
                                        value: itemValue.value,
                                    });
                                }
                                else if (keys === "RatingDate") {
                                    _amBestData.push({
                                        key: "AM Best Rating Date",
                                        value: (itemValue === null || itemValue === void 0 ? void 0 : itemValue.value) ? getDDMMYYYY(itemValue.value) : null,
                                    });
                                }
                                else if (keys === "FinancialSize") {
                                    _amBestData.push({
                                        key: "AM Best Financial Size",
                                        value: itemValue.value,
                                    });
                                }
                            }
                        }
                        setAmBestData(_amBestData);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_4 = _b.sent();
                    console.log(error_4);
                    setAMBesterror(true);
                    return [3 /*break*/, 5];
                case 4:
                    setAMBestLoader(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var fetchSANDPDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var sandPData, _sandPData, item, allKeys, _i, allKeys_3, keys, itemValue, error_5;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!id) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    setSANDPLoader(true);
                    return [4 /*yield*/, getSandPDetailsData({ MarketId: Number(id) })];
                case 2:
                    sandPData = _b.sent();
                    if ((_a = sandPData === null || sandPData === void 0 ? void 0 : sandPData.data) === null || _a === void 0 ? void 0 : _a.applicableToMarketFlag) {
                        _sandPData = [];
                        item = sandPData.data.fields;
                        allKeys = Object.keys(item);
                        for (_i = 0, allKeys_3 = allKeys; _i < allKeys_3.length; _i++) {
                            keys = allKeys_3[_i];
                            itemValue = item[keys];
                            if ((itemValue && typeof itemValue === 'object' && itemValue.applicableToMarketFlag && (itemValue).showLabel)) {
                                if (keys === "SandPRating") {
                                    _sandPData.push({
                                        key: "S&P Rating",
                                        value: itemValue.value,
                                    });
                                }
                                else if (keys === "RatingOutlook") {
                                    _sandPData.push({
                                        key: "S&P Outlook",
                                        value: itemValue.value,
                                    });
                                }
                                else if (keys === "RatingDate") {
                                    _sandPData.push({
                                        key: "S&P Rating Date",
                                        value: (itemValue === null || itemValue === void 0 ? void 0 : itemValue.value) ? getDDMMYYYY(itemValue.value) : null,
                                    });
                                }
                            }
                        }
                        setSANDPData(_sandPData);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_5 = _b.sent();
                    console.log(error_5);
                    setSandPError(true);
                    return [3 /*break*/, 5];
                case 4:
                    setSANDPLoader(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var FinancialDataBody = function () {
        return (React.createElement(UuiFlexlayout, { direction: "row", gap: "lg" },
            React.createElement("div", { className: "one-third-width" },
                " ",
                amBestData.map(function (data, index) {
                    return React.createElement("div", { key: index, style: { padding: "12px", } },
                        React.createElement("div", { style: { marginBottom: "7px", color: "grey" }, children: data.key }),
                        React.createElement("span", { style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                })),
            React.createElement("div", { className: "one-third-width" },
                " ",
                sANDPData.map(function (data, index) {
                    return React.createElement("div", { key: index, style: { padding: "12px", } },
                        React.createElement("div", { style: { marginBottom: "7px", color: "grey" }, children: data.key }),
                        React.createElement("span", { style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                })),
            React.createElement("div", { className: "one-third-width" }, financialLoader ?
                React.createElement("div", { style: { display: "flex", alignItems: "center", width: "270px" } },
                    React.createElement(UuiSpinner, { style: { marginLeft: "auto" }, variant: "small" })) : !finError ?
                React.createElement(UuiFlexlayout, { direction: "column", gap: "xs" }, financialData.map(function (data, index) {
                    return React.createElement("div", { key: index, style: { padding: "12px", } },
                        React.createElement("div", { style: { marginBottom: "7px", color: "grey" }, children: data.key }),
                        React.createElement("span", { style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                })) :
                React.createElement("div", null,
                    React.createElement(AonButton, { style: { paddingInline: "5px" }, variant: BUTTON_VARIANT.TEXT, onClick: function () { return fetchFinacialData(); } }, "Retry")))));
    };
    var handleRN = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    setInitialAPiLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!(pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.InsuranceEntityId)) return [3 /*break*/, 3];
                    return [4 /*yield*/, submitNotificationAlert([{
                                Subscribe: !(pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.IsUserSubscribedForRN), InsuranceEntityId: pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.InsuranceEntityId
                            }])
                        //await fetchConfig()
                    ];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    //await fetchConfig()
                    if (pageCheckBoxValues)
                        setPageCheckBoxValues(__assign(__assign({}, pageCheckBoxValues), { IsUserSubscribedForRN: !(pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.IsUserSubscribedForRN) }));
                    setInitialAPiLoading(false);
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    setInitialAPiLoading(false);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleFavorite = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    setInitialAPiLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!(pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.InsuranceEntityId)) return [3 /*break*/, 3];
                    return [4 /*yield*/, enableMarketFavorite([{
                                Subscribe: !(pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.IsFavorite), InsuranceEntityId: pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.InsuranceEntityId
                            }])
                        // await fetchConfig()
                    ];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    // await fetchConfig()
                    if (pageCheckBoxValues)
                        setPageCheckBoxValues(__assign(__assign({}, pageCheckBoxValues), { IsFavorite: !(pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.IsFavorite) }));
                    setInitialAPiLoading(false);
                    return [3 /*break*/, 5];
                case 4:
                    err_2 = _a.sent();
                    setInitialAPiLoading(false);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleSubscriptions = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    setInitialAPiLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!id) return [3 /*break*/, 5];
                    return [4 /*yield*/, checkmarketSubscription(id)];
                case 2:
                    response = _a.sent();
                    if (!!response.data.value.length) return [3 /*break*/, 3];
                    alert("No news availlable for this market");
                    return [2 /*return*/];
                case 3: return [4 /*yield*/, enableMarketNews([{
                            Subscribe: !(pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.IsUserSubscribedForNews), InsuranceEntityId: pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.InsuranceEntityId
                        }])];
                case 4:
                    _a.sent();
                    if (pageCheckBoxValues)
                        setPageCheckBoxValues(__assign(__assign({}, pageCheckBoxValues), { IsUserSubscribedForNews: !(pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.IsUserSubscribedForNews) }));
                    _a.label = 5;
                case 5:
                    setInitialAPiLoading(false);
                    return [3 /*break*/, 7];
                case 6:
                    err_3 = _a.sent();
                    setInitialAPiLoading(false);
                    console.log(err_3);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleCurrentMarket = function (market) {
        setMarketName(market.name);
        setMarketType(market.marketCategoryName);
        var words = market.name.split(" ");
        document.title = "".concat(appConfig.applicationName, " (").concat(words[0] ? words[0] : "", " ").concat(words[1] ? words[1] : "", "...) ");
    };
    return (React.createElement("div", { className: "marketDetailsContainer" },
        React.createElement(UuiOverlayLoader, { text: "Loading...", show: initialApiLoading }),
        showData && React.createElement(React.Fragment, null,
            React.createElement("div", { className: "market-details-heading" },
                " ",
                React.createElement("h2", null,
                    marketName,
                    " ",
                    marketType && "(" + marketType + ")",
                    "  ")),
            React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginBlock: "10px", marginTop: "50px" } },
                appConfig.applicationId === 2 && React.createElement("span", null,
                    React.createElement(AonCheckbox, { onClick: function (event) { handleFavorite(event); }, checked: pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.IsFavorite, label: "Favorite" }),
                    React.createElement("span", { style: { marginInline: "34px" } }, "Favorite ")),
                appConfig.applicationId === 2 && React.createElement("span", null,
                    React.createElement(AonCheckbox, { onClick: function (event) { handleSubscriptions(event); }, checked: pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.IsUserSubscribedForNews, label: "Favorite" }),
                    React.createElement("span", { style: { marginInline: "34px" } }, "News Subscription ")),
                (appConfig.applicationId === 1 || appConfig.applicationId === 2) &&
                    React.createElement("span", null,
                        React.createElement(AonCheckbox, { onClick: function (event) { handleRN(event); }, checked: pageCheckBoxValues === null || pageCheckBoxValues === void 0 ? void 0 : pageCheckBoxValues.IsUserSubscribedForRN, label: "Favorite" }),
                        React.createElement("span", { style: { marginInline: "34px" } }, "Ratings Notification "))),
            React.createElement("br", null),
            React.createElement(MarketDetailsPan, { id: Number(id), setMarket: handleCurrentMarket }),
            id && React.createElement(MarketGuideStatusPan, { id: id }),
            (!financialLoader && !financialData.length) ? null : React.createElement(AonPannel, { headerTitle: "Ratings and Key Financial Data", Body: React.createElement(FinancialDataBody, null) }),
            id && React.createElement(MarketTypeSpecificPan, { id: id }),
            React.createElement(MarketAddtionalInfo, null),
            React.createElement(MarketIntermediaries, null),
            id && React.createElement(MarketNewsAndResearchpan, { id: id })),
        !showData && !initialApiLoading && React.createElement("div", { style: { marginLeft: window.innerWidth / 2.5, marginTop: window.innerHeight / 2.5 } },
            "Sorry!! This Market is not found in ",
            appConfig.applicationName,
            "!!")));
});
export default MarketDetails;
